import { tabsClasses, useMediaQuery } from "@mui/material";
import React, { useState } from "react";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { TabsWrapper } from "assets/styles/globalStyledComponent";
import { Box } from "@mui/system";
import SessionIndependent from "./SessionIndependent";
import SessionDependent from "./SessionDependent";

const SerialNumber = () => {
  const [value, setValue] = useState("1");
  const isMobile = useMediaQuery("(max-width: 768px)");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <TabContext value={value}>
      <Box sx={{ px: { xs: 1, sm: 2 }, pt: 1 }}>
        <TabsWrapper sx={{ width: isMobile ? "100%" : "auto", mb: 1.5 }}>
          <TabList
            onChange={handleChange}
            variant="scrollable"
            scrollButtons={isMobile}
            allowScrollButtonsMobile
            sx={{
              [`& .${tabsClasses.scrollButtons}`]: {
                "&.Mui-disabled": { opacity: 0.3 },
              },
              width: isMobile ? "85vw" : "auto",
            }}
            aria-label="ekalsutra erp tab"
          >
            <Tab label="Session Independent" value="1" />
            <Tab label="Session Dependent" value="2" />
          </TabList>
        </TabsWrapper>
      </Box>
      <TabPanel value="1" sx={{ p: "0 !important", mt: 0.5 }}>
        <Box sx={{ my: 1 }}>
          <SessionIndependent />
        </Box>
      </TabPanel>
      <TabPanel value="2" sx={{ p: "0 !important", mt: 0.5 }}>
        <Box sx={{ my: 1 }}>
          <SessionDependent />
        </Box>
      </TabPanel>
    </TabContext>
  );
};

export default SerialNumber;
